import { Component } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CommonModule } from '@angular/common';
import { BaseFormControl } from '../base/base-form-control.directive';

@Component({
    selector: 'app-toggle',
    standalone: true,
    templateUrl: './toggle.component.html',
    styleUrl: './toggle.component.scss',
    imports: [MatSlideToggleModule, CommonModule]
})
export class ToggleComponent extends BaseFormControl<boolean> { }
